import useProject from '@hooks/useProject';
import { useMemo } from 'react';

function useInquiryInfo() {
    const project = useProject();
    const inquiryInfo = project?.inquiryInfo;

    const phoneContent = useMemo(() => {
        if (inquiryInfo) {
            const { phoneNote, phoneBusinessHours } = inquiryInfo;
            return [phoneNote, phoneBusinessHours].filter(Boolean).join('\n');
        }
        return '';
    }, [inquiryInfo]);

    const externalContent = useMemo(() => {
        if (inquiryInfo) {
            const { externalPhoneNumber, externalBusinessHours } = inquiryInfo;
            return [externalBusinessHours, externalPhoneNumber].filter(Boolean).join('\n');
        }
        return '';
    }, [inquiryInfo]);

    return {
        inquiryInfo,
        phoneContent,
        externalContent,
    };
}

export default useInquiryInfo;
